
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.scheduled-webinars {
  grid-column: content;
  padding: 40px 0;
  max-width: $container-max-width;
  width: 100%;
  margin: 0 auto;

  > * + * {
    margin-top: 2em;
  }
}

.scheduled-webinars__wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, auto));
  grid-gap: 50px;
}

.scheduled-webinar {
  background: $light-gray-legacy;
  padding: 26px 34px;
  position: relative;
  cursor: pointer;
  border-radius: 6px;
  transition: transform 0.5s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  &:hover {
    transform: translateY(-10px);
  }
}

.scheduled-webinar__title {
  margin-bottom: 7px;

  & span {
    font-size: 18px;
  }
}

.scheduled-webinar__date {
  margin-bottom: 4px;
}

@include media-query(tablet) {
  .scheduled-webinars__wrapper {
    grid-template-columns: repeat(2, 1fr);
  }

  .scheduled-webinars {
    padding: 60px 0;
  }

  .scheduled-webinar__title span {
    font-size: 26px;
    line-height: 1.25;
    margin-bottom: 10px;
  }

  .scheduled-webinar__date {
    margin-bottom: 30px;
  }
}

@include media-query(desktop) {
  .scheduled-webinars__wrapper {
    grid-template-columns: repeat(3, 1fr);
  }
}
`